import React from 'react'
import classNames from 'classnames'
import createRenderer from 'components/FormField'
import { FormLabel } from 'components'
import './url.scss'

const Url = createRenderer(
	(input, label, description, disabled = false, id, rest) => (
		<>
			{label && (
				<FormLabel
					htmlFor={id}
					text={label}
					description={description}
				/>
			)}
			<div className="o-url">
				<div
					className={classNames('c-form__input o-url__static', {
						'is-disabled': disabled,
					})}
				>
					skara.io/
					{/* {JSON.stringify(disabled)} */}
				</div>
				<input
					type="text"
					id={id}
					className="c-form__input o-url__input"
					disabled={disabled || disabled.length ? disabled : false}
					{...input}
					{...rest}
				/>
			</div>
		</>
	)
)

export default Url
